import useDealRequest, {
  EDealRequestType,
  IDealRequestCommonSchema,
} from '../../../../../../api/hooks/use-deal-request';
import { toast } from 'react-toastify';
import { MarketTypes } from 'api/types';
import BottomSheetConfirm from 'components/bottom-sheet-confirm';
interface IModalSupportDealProps {
  isOpen: boolean;
  onDismiss: (value: boolean) => void;
  onAllReset?: () => void;
  marketType: MarketTypes;
  facilityId: number;
  title?: string;
  type?: 'service' | 'support';
}

const TEXT = `Отправьте заявку и мы отправим вам экспертный расчет рыночной стоимости в течении 2х рабочих дней.`;

const ModalSupportDeal = ({
  isOpen,
  facilityId,
  onDismiss,
  onAllReset,
  marketType,
}: IModalSupportDealProps) => {
  const { error, isMutating, trigger } = useDealRequest();

  const handleSubmit = async () => {
    await trigger({
      marketType: marketType,
      type: EDealRequestType.Estimate,
      data: {
        facilityId: facilityId,
      } as IDealRequestCommonSchema,
      mode: 'inSystem',
    });
    toast.success(
      'Ваша заявка принята, наш эксперт свяжется с вами в течении 2х часов в рабочее время.',
    );
    onAllReset && onAllReset();
    onDismiss(false);
  };

  return (
    <BottomSheetConfirm
      isOpen={isOpen}
      onDismiss={() => onDismiss(false)}
      onAgree={handleSubmit}
      title={'Заявка на расчет'}
      isLoading={isMutating}
      nameAction='Отправить'
      text={TEXT}
    />
  );
};

export default ModalSupportDeal;
